import { useState } from 'react';
import { useAppContext } from 'components/Context/AppContext';
import { useDispatch, useSelector } from 'react-redux';
import Modals from '../Modals';
import TextAreaInput from 'components/Global/TextArea';
import { Button } from 'components/Global';
import { ReactComponent as DriverIcon } from 'icons/driving-wheel-icon.svg';
import { ReactComponent as CloseIcon } from 'icons/x-sign-black-icon.svg';
import { processDriverVerification } from 'features/drivers/actions';
import { useNavigate } from 'react-router-dom';

const RejectDriverModal = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // CONTEXT
  const { showToast, setShowRejectDriverModal } = useAppContext();

  // GLOBAL STATE
  const driverData = useSelector((state) => state.drivers.selected);

  // LOCAL STATE
  const [rejectMessage, setRejectMessage] = useState('');

  // SUBMIT ACTION
  const handleSubmit = async () => {
    // validation
    const validrejectMessage = rejectMessage.replace(/\s/g, '').length !== 0;
    // check if not valid return error toast
    if (!validrejectMessage) {
      return showToast({ type: 'error', message: 'Tulis Alasan Penolakan' });
    }
    const payload = {
      id: driverData.id,
      data: { status: 'rejected', reject_reason: rejectMessage },
    };

    try {
      await dispatch(processDriverVerification(payload)).unwrap();
      setShowRejectDriverModal(false);
      showToast({ type: 'success', message: 'Verifikasi driver berhasil ditolak' });
      navigate('/driver?tab-active=Verifikasi+Driver+Baru', { replace: true });
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);
      showToast({ type: 'error', message: 'Gagal proses verifikasi tolak driver' });
    }
  };

  return (
    <Modals
      setState={setShowRejectDriverModal}
      icon={<DriverIcon fill="#009EF7" width="25px" height="25px" />}
      title="Tolak Driver"
    >
      <div className="reject-driver">
        <button className="reject-driver__close-button" onClick={() => setShowRejectDriverModal(false)}>
          <CloseIcon />
        </button>
        {/* TEXT AREA */}
        <div className="reject-driver__message">
          <TextAreaInput
            className="reject-driver__message__textarea"
            style={{ height: '219px' }}
            value={rejectMessage}
            onChange={(e) => setRejectMessage(e.target.value)}
            placeholder="Masukkan Keterangan"
            label="Tulis Keterangan Penolakan Driver"
          />
        </div>

        {/* BUTTON */}
        <div className="reject-driver__button">
          <Button type="button" width={131} variant="primary" size="md" onClick={handleSubmit}>
            Kirim
          </Button>
        </div>
      </div>
    </Modals>
  );
};

export default RejectDriverModal;
